module.exports = __webpack_public_path__ + "img/bg_highspeed.ece0e26e.jpg";